/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Domain_Manager_SubtitleInputs */

const en_domain_manager_subtitle = /** @type {(inputs: Domain_Manager_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orchestrate your portfolio of connected domains`)
};

const es_domain_manager_subtitle = /** @type {(inputs: Domain_Manager_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orquesta tu portafolio de dominios conectados`)
};

const fr_domain_manager_subtitle = /** @type {(inputs: Domain_Manager_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orchestrez votre portefeuille de domaines connectés`)
};

const de_domain_manager_subtitle = /** @type {(inputs: Domain_Manager_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orchestriere dein Portfolio an verbundenen Domains`)
};

/** @type {(inputs: Domain_Manager_SubtitleInputs) => LocalizedString} */
const ja_domain_manager_subtitle = en_domain_manager_subtitle;

/** @type {(inputs: Domain_Manager_SubtitleInputs) => LocalizedString} */
const zh_domain_manager_subtitle = en_domain_manager_subtitle;

/** @type {(inputs: Domain_Manager_SubtitleInputs) => LocalizedString} */
const ar_domain_manager_subtitle = en_domain_manager_subtitle;

/** @type {(inputs: Domain_Manager_SubtitleInputs) => LocalizedString} */
const id_domain_manager_subtitle = en_domain_manager_subtitle;

/** @type {(inputs: Domain_Manager_SubtitleInputs) => LocalizedString} */
const it_domain_manager_subtitle = en_domain_manager_subtitle;

/** @type {(inputs: Domain_Manager_SubtitleInputs) => LocalizedString} */
const ru_domain_manager_subtitle = en_domain_manager_subtitle;

/** @type {(inputs: Domain_Manager_SubtitleInputs) => LocalizedString} */
const pt_domain_manager_subtitle = en_domain_manager_subtitle;

/** @type {(inputs: Domain_Manager_SubtitleInputs) => LocalizedString} */
const ko_domain_manager_subtitle = en_domain_manager_subtitle;

/**
* | output |
* | --- |
* | "Orchestrate your portfolio of connected domains" |
*
* @param {Domain_Manager_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_manager_subtitle = /** @type {((inputs?: Domain_Manager_SubtitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Manager_SubtitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_manager_subtitle(inputs)
	if (locale === "es") return es_domain_manager_subtitle(inputs)
	if (locale === "fr") return fr_domain_manager_subtitle(inputs)
	if (locale === "de") return de_domain_manager_subtitle(inputs)
	if (locale === "ja") return ja_domain_manager_subtitle(inputs)
	if (locale === "zh") return zh_domain_manager_subtitle(inputs)
	if (locale === "ar") return ar_domain_manager_subtitle(inputs)
	if (locale === "id") return id_domain_manager_subtitle(inputs)
	if (locale === "it") return it_domain_manager_subtitle(inputs)
	if (locale === "ru") return ru_domain_manager_subtitle(inputs)
	if (locale === "pt") return pt_domain_manager_subtitle(inputs)
	return ko_domain_manager_subtitle(inputs)
});